import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';

const initialState = {
	transactions: [],
	analysisMonths: [],
	initialBalance: {},
	finalBalance: {},
	income: [],
	incomeMonthly: {},
	expenses: [],
	expensesMonthly: {},
	hiddenFlow: [],
	hiddenMonthly: {},
	otherFinancials: [],
	otherFinancialsMonthly: {},
	dailyBalances: [],
	totalDays: 0,
	monthlyBalance: [],
	loanPayday: false,
	loanId: null,
	loading: false,
	updated: false,
	noTransactions: false,
};

const slice = createSlice({
	name: 'loan/analysis',
	initialState,
	reducers: {
		analysisRequestFailed: (analysis, action) => {
			analysis.loading = false;
			analysis.noanalysis = true;
		},
		analysisRequested: (analysis, action) => {
			analysis.loading = true;
		},
		analysisReceived: (analysis, action) => {
			const { data } = action.payload;
			analysis.transactions = data.transactions;
			analysis.analysisMonths = data.analysis_months;
			analysis.initialBalance = data.initial_balance;
			analysis.finalBalance = data.final_balance;
			analysis.hiddeexcenFlow = data.hidden_flow;
			analysis.hiddenMonthly = data.hidden_monthly;
			analysis.income = data.income;
			analysis.incomeMonthly = data.income_monthly;
			analysis.expenses = data.expenses;
			analysis.expensesMonthly = data.expenses_monthly;
			analysis.otherFinancials = data.other_financial;
			analysis.otherFinancialsMonthly = data.other_financial_monthly;
			analysis.dailyBalance = data.daily_balance;
			analysis.monthlyBalance = data.monthly_balance;
			analysis.loanPayday = data.loan_payday;
			analysis.loanId = data.loan_id;
			if (action.payload.data.transactions.length === 0) analysis.noTransactions = true;
			else analysis.noTransactions = false;
			analysis.loading = false;
			analysis.lastFetch = Date.now();
			analysis.updated = false;
		},
		analysisReseted: (analysis, action) => (analysis = initialState),
		analysisAdded: (analysis, action) => {},
		analysisDeleted: (analysis, action) => {},
		analysisUpdated: (analysis, action) => {},
		searchTextChanged: (analysis, action) => {
			analysis.searchText = action.payload;
		},
		analysisRelated: (analysis, action) => {
			analysis.updated = true;
		},
	},
});

export const {
	analysisAdded,
	analysisReceived,
	analysisRequested,
	analysisRequestFailed,
	searchTextChanged,
	analysisUpdated,
	analysisDeleted,
	analysisRelated,
	analysisReseted,
} = slice.actions;

export const loadTransactionsAnalysis = loanId => (dispatch, getState) => {
	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url: `/loans/${loanId}/transaction-analysis`,
			onStart: analysisRequested.type,
			onSuccess: analysisReceived.type,
			onError: analysisRequestFailed.type,
		})
	);
};

export default slice.reducer;
